export default __webpack_public_path__ + "static/media/single-4.53246c45.jpg";